import { RouteTypes } from 'consts';
import Header from 'containers/Header';
import Table from 'containers/Table';
import { useList } from 'hooks/list';
import { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { RfUiBreadcrumbs, RfUiModal } from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  setLoading,
  setModalDraftType,
  setMsgSubmit,
} from 'store/app/actions';
import {
  getInformesHoras,
  getInformesHorasCount,
  getInformesHorasExcel,
  setInformesHorasCount,
} from 'store/informes/actions';
import {
  makeSelectAllInformesCursosFilter,
  makeSelectInformesHoras,
  makeSelectInformesHorasCount,
} from 'store/informes/selectors';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import {
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
  makeSelectPerfilesUsuarioIdUsuario,
} from 'store/usuarios/selectors';
import {
  getTodayMinusOneMonthStartDate,
  getTodayMinusOneYearStartDate,
} from 'utils/dates-validators';
import { hasAccess } from 'utils/listUtils';
import { parseDateTime } from 'utils/parsePractices';
import { formatMinutes } from 'utils/practiceUtils';
import { userProfile } from 'utils/profilesIndex';
import { ReportHoursFilter } from './ReportHoursFilter/ReportHoursFilter';
import { makeSelectModalDraftType, makeSelectMsgSubmit } from 'store/app/selectors';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  idUsuario: makeSelectPerfilesUsuarioIdUsuario(),
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  cursos: makeSelectInformesHoras(),
  cursosCount: makeSelectInformesHorasCount(),
  allInformesCursosFilter: makeSelectAllInformesCursosFilter(),
} as any);

export const nomPaginaIH = 'Informes de horas';
const links = [
  {
    label: 'Informes',
    link: '#',
    textHelp: 'Informes',
    active: true,
  },
];

const today = new Date().getTime().toString();

const options =
  '[{"label": "Fecha inicio de menor a mayor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "asc"},"active": "true"},{"label": "Fecha inicio de mayor a menor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de mayor a menor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de menor a mayor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "asc"},"active": "false"}]';

const iconOrderConstant = 'Icono de ordenar';

const Courses = (): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    access_token,
    msgSubmit,
    modalDraftType,
    cursos,
    profileActive,
    cursosCount,
    allInformesCursosFilter,
    idUsuario,
  } = useSelector<any, any>(selectors);
  const redirect = (e: any) => {
    history.push(e.detail);
  };
  // fechaInicio: getTodayMinus15(),
  const initFilter = {
    elemInicio: 0,
    elemFin: 25,
    elemFinal: 25, // Algunas peticiones cambian el nombre del parámetro
    fechaInicio:
      (profileActive?.ID_PERFIL === '511' || profileActive?.ID_PERFIL === '611' || profileActive?.ID_PERFIL === '711')
        ? getTodayMinusOneMonthStartDate().toString()
        : getTodayMinusOneYearStartDate().toString(),
    fechaFin: today,
    orden: '',
    ascDesc: '',
    sociedades: '',
    estadosCurso: 'IN',
    cursos: '',
    alumnos:
      profileActive?.ID_PERFIL === '111' ||
        profileActive?.ID_PERFIL === '112' ||
        profileActive?.ID_PERFIL === '121' ||
        profileActive?.ID_PERFIL === '122' ||
        profileActive?.ID_PERFIL === '123'
        ? idUsuario
        : '',
    provincias: '',
  };

  const {
    filterRef,
    data,
    setData,
    headers,
    handleFilterTable,
    handleFilterChange,
  } = useList(
    { ...initFilter },
    [
      {
        text: 'Curso',
        orderBy: 'asc',
        ariaLabelIcon: iconOrderConstant,
      },
      { text: 'Nombre curso' },
      {
        text: 'Matrícula Alumno'
      },
      {
        text: 'Nombre Alumno',
        orderBy: 'asc',
        ariaLabelIcon: iconOrderConstant,
      },
      {
        text: 'Fecha de inicio',
        orderBy: 'asc',
        ariaLabelIcon: iconOrderConstant,
      },
      {
        text: 'Fecha de fin',
        orderBy: 'asc',
        ariaLabelIcon: iconOrderConstant,
      },
      { text: 'Horas validadas conducción efectiva' },
      { text: 'Horas pendientes conducción efectiva' },
      { text: 'Horas otras prácticas' },
      { text: 'Horas pendientes otras prácticas' },
    ],
    {
      action: (filter) => dispatch(getInformesHoras(filter)),
      headerToAPIMap: {
        Curso: 'ID_CURSO',
        Alumno: 'ID_ALUMNO',
        'Fecha de inicio': 'FECHA_INI_SERVICIO',
        'Fecha de fin': 'FECHA_FIN_SERVICIO',
      },
    },
    (filter) => {
      dispatch(setInformesHorasCount(0));

      dispatch(getInformesHoras(filter));
      dispatch(getInformesHorasCount(filter));
    },
    async () => {
      dispatch(setLoading(true));
      await new Promise(resolve => setTimeout(resolve, 90));
      dispatch(setLoading(false));
    }
  );

  const handleExportExcel = () => {
    const excelColumns = [...headers];
    dispatch(
      getInformesHorasExcel({
        filter: { ...filterRef.current },
        excelConfig: {
          literals: [...excelColumns],
        },
      })
    );
  };

  useEffect(() => {
    if (profileActive) {
      if (
        profileActive?.ID_PERFIL === '111' ||
        profileActive?.ID_PERFIL === '112' ||
        profileActive?.ID_PERFIL === '121' ||
        profileActive?.ID_PERFIL === '122' ||
        profileActive?.ID_PERFIL === '123'
      ) {
        filterRef.current.alumnos = idUsuario;
      }
      dispatch(getInformesHoras(filterRef.current));
      dispatch(getInformesHorasCount(filterRef.current));
    }
  }, [profileActive, allInformesCursosFilter]);
  const accessToAlumns = hasAccess(profileActive, [
    userProfile.formador,
    userProfile.gestor,
    userProfile.administrador,
    userProfile.supervisor,
    userProfile.visualizador
  ]);
  useEffect(() => {
    if (!profileActive || !allInformesCursosFilter.length) {
      return;
    }

    const cursosParsed = cursos.map((item) => {
      const link = accessToAlumns ? '/listado-alumnos/' + item.ID_CURSO : '';

      return {
        table: [
          [
            { text: item.ID_CURSO, urlLink: link },
            {
              text: allInformesCursosFilter.find(
                (curso) => curso.ID_CURSO == item.ID_CURSO
              )?.NOMBRE_CURSO,
            },
            { text: item.ID_ALUMNO },
            { text: item.nombre_parsed },
            { text: parseDateTime(new Date(Number(item.FECHA_INI_JORNADA))) },
            { text: parseDateTime(new Date(Number(item.FECHA_FIN_JORNADA))) },
            { text: formatMinutes(item.HORAS_VALIDADAS_CONDUCCION_EFECTIVA) },
            {
              text: formatMinutes(
                item.HORAS_PENDIENTES_VALIDAR_CONDUCCION_EFECTIVA
              ),
            },
            { text: formatMinutes(item.HORAS_VALIDADAS_OTRAS) },
            { text: formatMinutes(item.HORAS_PENDIENTES_VALIDAR_OTRAS) },
          ],
        ],
      };
    });

    setData(cursosParsed);
  }, [cursos, allInformesCursosFilter]);

  if (
    !hasAccess(profileActive, [
      userProfile.gestor,
      userProfile.administrador,
      userProfile.formador,
      userProfile.alumno.extAspirante,
      userProfile.alumno.extBecario,
      userProfile.alumno.extMaquinista,
      userProfile.alumno.intBecario,
      userProfile.alumno.intMaquinista,
      userProfile.supervisor,
      userProfile.visualizador,
    ])
  ) {
    return <Redirect to={RouteTypes.HOME} push />;
  }

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  return (
    <>
      <Header />
      <div className="rf-layout-table rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">Informes de horas</h1>

        <ReportHoursFilter handleSubmit={handleFilterChange} />

        <Table
          redirect={(e: any) => {
            redirect(e);
          }}
          list={false}
          data={data}
          dataCount={cursosCount}
          headers={headers}
          handleFilter={handleFilterTable}
          hideAudit={true}
          handleExportExcel={handleExportExcel}
          pagination25={true}
          orderMobile={true}
          itemsOnLeft={4}
          orderOptions={options}
        />
        <RfUiModal
          title-modal={msgSubmit}
          modalConfirmText="Aceptar"
          id-modal="modalDraft"
          modal-type={modalDraftType}
          onModalClose={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
          onConfirm={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
        ></RfUiModal>
      </div>
    </>
  );
};

export default Courses;
